<template>
  <PopupXSmall @close="close">
    <div class="con">
      <div class="tit">{{ t('select_format') }}</div>
      <div class="sel-wrap">
        <label for="file01" class="file-select">
          <img :src="getAssetImageUrl('common/icons/word-icon.svg')" alt="WORD" />
          <span>WORD</span>
          <input v-model="form.downloadFormat" type="radio" name="file" id="file01" value="WORD" />
        </label>
        <label for="file02" class="file-select">
          <img :src="getAssetImageUrl('common/icons/pdf-icon.svg')" alt="PDF" />
          <span>PDF</span>
          <input v-model="form.downloadFormat" type="radio" name="file" id="file02" value="PDF" />
        </label>
        <label for="file03" class="file-select">
          <img :src="getAssetImageUrl('common/icons/text-icon.svg')" alt="TEXT" />
          <span>TEXT</span>
          <input v-model="form.downloadFormat" type="radio" name="file" id="file03" value="TEXT" />
        </label>
      </div>
      <!--      임시주석처리-->
      <!--      <div v-if="downloadForm.downloadType === 'HISTORY'" class="agree-ck-wrap">-->
      <!--        <input v-model="form.includeSummary" type="checkbox" id="agree-ck" class="app-ck" />-->
      <!--        <div class="app-ck-wrap">-->
      <!--          <label for="agree-ck" class="app-ck-icon">-->
      <!--            <IconCheck></IconCheck>-->
      <!--          </label>-->
      <!--          <span>{{ t('label_summarize') }}</span>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="btn-wrap">
        <button type="button" class="gray-btn m-btn" @click="cancel">
          <span>{{ t('label_cancel') }}</span>
        </button>
        <button type="button" class="primary-btn m-btn" @click="confirm">
          <span>{{ t('button_save') }}</span>
        </button>
      </div>
    </div>
  </PopupXSmall>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import PopupXSmall from '@/components/shared/composite/PopupXSmall.vue';
import { ScriptDownloadForm } from '@/types/components';
import { RequestScriptDownload } from '@/types/request';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const isVisible = defineModel<boolean>({
  required: true,
  default: true,
});

const props = withDefaults(
  defineProps<{
    downloadForm: ScriptDownloadForm;
  }>(),
  {
    downloadForm: () => ({
      downloadType: 'REAL_TIME',
      chatId: '',
      languageCode: 'ko',
    }),
  }
);

const emit = defineEmits<{
  close: [];
  cancel: [];
  confirm: [form: RequestScriptDownload];
}>();

const form = ref<RequestScriptDownload>({
  languageCode: props.downloadForm.languageCode,
  downloadFormat: 'WORD',
  includeSummary: false,
});

const { t } = useI18n();

const confirm = () => {
  emit('confirm', form.value);
  close();
};
const cancel = () => {
  emit('cancel');
  close();
};
const close = () => {
  emit('close');
  isVisible.value = false;
};
</script>
<style scoped lang="scss">
.con {
  .tit {
    font-size: $font-size-psmall;
    padding-bottom: 0.5rem;
    color: var(--font-default);
  }
  .txtarea-box {
    span {
      font-size: $font-size-xs;
      color: $color-gray-200;
      padding: 0.25rem 0;
      display: block;
      text-align: right;
    }
  }
  .btn-wrap {
    width: 100%;
    display: flex;
    gap: $size-s;
    margin-top: $size-l;
    button {
      width: calc(50% - 4px);
    }
  }
  .agree-ck-wrap {
    padding: 0.75rem 0.5rem 0.5rem;
  }
}

.file-select {
  border: 1px solid $color-gray-40;
  width: 100%;
  padding: 0.5rem;
  border-radius: $size-m;
  display: flex;
  margin-bottom: $size-s;
  &:last-child {
    margin-bottom: 0;
  }
  span {
    font-size: $font-size-psmall;
    font-weight: 500;
    color: var(--font-default);
  }
  input[type='radio'] {
    display: none;
  }
  &:has(input:checked) {
    border: 1px solid $color-navy-100;
    background: $primary-bg;
    span {
      color: $color-navy-100;
    }
    svg {
      color: $color-navy-100;
    }
  }
}
</style>
